export enum EUserPermission {
    ACCESS_COMPANY_ACCOUNT_CONFIGURATION = 'ACCI',
    SEE_REPORTS_ANALYTICS_SECTION = 'VRAA',
    SEE_TEAM_MEMBERS_ORDERS = 'VTOR',
    APPROVE_TEAM_MEMBERS_ORDERS = 'APTO',
    CREATE_NEW_ORDER = 'CROR',
    EDIT_ORDER = 'EDOR',
    PRE_APPROVE_ORDER = 'PRAP',
    SEE_ORDER_FINANCE = 'SORF',
    LIMITED_VESSELS_ACCESS = 'LVAC',
}
